var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("sc-taginput", {
    attrs: {
      "allow-new": false,
      autocomplete: "",
      data: _vm.locallogisticProviders,
      field: "name",
      "open-on-focus": true,
      placeholder: "Selecione",
      loading: _vm.loading
    },
    on: {
      input: function(text) {
        return _vm.getFilteredTags(text, _vm.logisticProvidersModel)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(props) {
          return [_vm._v("\n      " + _vm._s(props.option.name) + "\n    ")]
        }
      }
    ]),
    model: {
      value: _vm.logisticProvidersModel,
      callback: function($$v) {
        _vm.logisticProvidersModel = $$v
      },
      expression: "logisticProvidersModel"
    }
  })
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37c7fdfd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37c7fdfd","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./node_modules/@intelipost-modules/secure-psl/features/list/components/ScLpTaginput.vue
// module id = null
// module chunks = 